module.exports = __webpack_public_path__ + "static/VietNam_dark-086ed2429f2aa175aef20f4fb2d75bed.svg";